import { ProductTypes } from "@components/Data/enums";
import { KeyedMutator } from "swr";

export enum TypesOfDiscount {
  ONLINE = "online",
  DOCTOR = "doctor",
  STAFF = "staff",
  NRI = "nri",
  IN_LIEU="inlieu",
  FAMILY="family",
  ONE_TIME="oneTime"
}

export enum Variants {
  BRONZE = "bronze",
  BRONZE0 = "bronze0",
  PLAN1 = "plan1",
  GOLD = "gold",
  VARIANT1 = "variant1",
  PLATINUM = "platinum",
}

export enum AddOnKeys {
  DISEASE_MANAGEMENT = "diseaseManagement",
  ACUTE_CARE = "acuteCarePlans",
  SAFEGUARD_BENEFIT = "safeguardBenefit",
  SAFEGUARD_PLUS_BENEFIT = "safeguardPlusBenefit",
  HOSPITAL_CASH = "hospitalCash",
  PERSONAL_ACCIDENT_COVER = "personalAccidentCover",
  ROOM_MODIFICATION = "roomModification",
  COPAYMENT = "copayment",
  DEDUCTIBLES = "deductibles",
  PPN = "ppn",
  FAST_FORWARD = "fastForward",
  FUTURE_READY = "futureReady",
  INTERNATIONAL_COPAYMENT = "internationalCopayment",
  PED = "ped",
  CRITICAL_ILLNESS = "criticalIllness",
  ACCUMALATE = "accumalate",
  OPD = "opd",
  PA_COMBO = "paCombo",
  E_CONSULTATION = "eConsultation",
  E_INTL_COVER = "eIntlCover",
  PREMIUM_WAIVER = "premiumWaiver",
  ENHANCED_LOYALTY = "enhancedLoyalty",
  HEALTH_COACH = "healthCoach",
  ENHANCED_NCB = "enhancedNCB",
  ENHANCED_REFILL = "enhancedRefill",
  COPAYMENT_20 = "copayment-20",
  AH = "ah",
  TTD = "ttd",
  LUMPSUM = "lumpsum",
  TIERED_NETWORK="tieredNetwork",
  UNLOCK_NETWORK="unlockNetwork",
  ANNUAL_HEALTH_CHECKUP="annualHealthCheckup",
  MODERN_TREATMENT="modernTreatment",
  PRE_POST_ENHANCEMENT="prePostEnhancement",
  SECOND_MEDICAL_OPINION="secondMedicalOpinion"
}
export interface ProductDetails {
  typesOfDiscount: string[];
  productVariants: Record<string, string>[];
  policyTenure: number[];
  addOns: any;
  sumInsuredRange: SumInsuredRange;
  discounts: Discounts;
  costSharing: Record<string, any>;
  sumInsurance: any;
}

export interface SumInsuredRange {
  titanium: string[];
  platinum: string[];
  bronze: string[];
}

export interface Discounts {
  percentageValue: PercentageValue;
}

export interface PercentageValue {
  cohort: string;
  tax: string;
  online: string;
  staff: string;
  doctor: string;
  personalAccident: string;
  hospitalCash: string;
  familyDiscount: string;
  personalAccidentCombo: string;
  paStaffDiscount: string;
  modalFactor: string;
  policyTenure: Record<string, any>;
  safeGuardBenefit: Record<string, string>;
  safeGuardPlusBenefit: Record<string, string>;
  coHortDiscount: string;
  vintageLoading: Record<string, any>;
  flatDiscount1Year:string;
  flatDiscount2Year:string;
  flatDiscount3Year:string;
  zonalLoading:Record<string, string>;
  flexi:Record<string, string>;
  oneTimeDiscount:string
  inlieu:Record<string, string>;
}

export interface QuoteDetailsProps {
  productName: ProductTypes;
  productDetails: ProductDetails;
  zones: Record<string, number>;
  origin?: string;
  cities: Cities;
  productLabels: Record<string, any>;
  productRoutes:ProductRoute[]
  occupationMasterData?: OccupationMaster[];
  retailFlag?:any;
  multi?: boolean;
}

export interface Cities {
  cities: string[];
  popularCities: string[];
  states:any
}

export interface DetailsFormValues {
  city: string;
  email: string;
  adults: number;
  childs: number;
  dob: string;
  adultsDob: string[];
  childsDob: string[];
  plan: PlanTypes;
  phoneNumber: string;
  name?: string;
  isPortCase?: boolean;
  adultPortabilityDetails?: PortabilityDetails[] | {};
  childPortabilityDetails?: PortabilityDetails[] | {};
  employementInformation?: EmployementInformation;
}
export interface DetailsFormProps {
  title?: string;
  initialValues?: any;
  cities: Cities;
  quoteId: string;
  origin?: string;
  productType?: string;
  multi?: boolean;
  edit?: boolean;
  onSuccess?: (data: any, formData: any) => void;
  retailFlag?: boolean;
  setFirstRender?: any;
  setShowEditForm?: any;
  setSignzyApiStatus?: (() => void);
  priceMutate?: KeyedMutator<any>;
  mutate?:KeyedMutator<any>;
  queryToGetPrice?: any;
  setQueryToGetPrice?:any;
  zones?: any;
  finalPrice?:any;
  priceCalculator?:any;
  tenure?:any,
  productRoutes?:ProductRoute[];
  setPayOnConfirmEdit?:any;
  payOnConfirmEdit?:boolean
  occupationMasterData?: OccupationMaster[];
  onlyEditNoPay?:boolean;
  setDataUnderEdit?:any;
  isEdit?:boolean;
  memberBasedAddons?:any;
  onReset?:any
}

export enum TypesOfCostSharing {
  COPAYMENT = "copayment",
  DEDUCTIBLES = "deductibles",
}

export enum PlanTypes {
  INDIVIDUAL = "individual",
  FAMILY = "family",
  MULTI_INDIVIDUAL = "multi-individual",
}

export interface PortabilityDetails {
  dateOfBirth: string;
  ported: boolean;
  coverageYears: number;
}
export interface EmployementInformation {
  annualSalary: number;
  employementType: "SELF_EMPLOYED" | "SALARIED";
  occupation: string;
}

export interface OccupationMaster {
  _id: string;
  occupation: string;
  riskClass: string;
  riskClassOption: string;
}
export enum TypesOfPayment {
  ONE_TIME = "oneTime",
  FLEXI = "flexi",
}
export const PaymentOptions = [
{
  label:"One Time Payment",
  value:"oneTime"
},
{
  label:"Flexi Payment",
  value:"flexi"
}
]

